<p-dialog
  [styleClass]="styleClass"
  [header]="header"
  [visible]="visible"
  [modal]="modal"
  [closable]="closable"
  [draggable]="draggable"
  [resizable]="resizable"
  [dismissableMask]="dismissableMask"
  [style]="dialogStyle"
  [breakpoints]="breakpoints"
  [contentStyle]="contentStyle"
  (visibleChange)="onVisibleChange($event)"
  (onHide)="hide.emit()">
  <ng-content></ng-content>
  <ng-template pTemplate="footer">
    <ng-content select="[footer]"></ng-content>
  </ng-template>
</p-dialog>
